/**
 * 本文件由 scripts/genSvgIconHash.js 脚本动态生成，请勿手动修改。
 * 供 IconFont（SVG）与 CI 上传脚本解析 OSS 路径版本号。
 */
export const SVG_ICON_HASH = 'b95a46e3' as const;
